import React, { useState } from "react";

import styles from "./BoxItem.module.css";
import classNames from "classnames";
import { IConveyorBoxItemUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import { IAdjustedPickedQuantityActions } from "../OrderOverview/OrderOverview";
import { LimaOrderStatus } from "../../../lib/lima/LimaOrderStatus";
import BoxItemPickProgress from "./parts/BoxItemPickProgress.tsx";
import BoxItemSkuInfo from "./parts/BoxItemSkuInfo";
import BoxItemImage from "./parts/BoxItemImage";
import BoxItemHeader from "./parts/BoxItemHeader";
import BoxItemOverlays from "./parts/BoxItemOverlays";
import BoxItemCard from "./parts/BoxItemCard";

type Props = {
  orderSkuIds: Array<number>;
  item: IConveyorBoxItemUI;
  onConfirmExcessPicks: (conveyorBoxItemID: number) => void;
  onAutoVerifyQuantity: (itemId: number) => void;
  isFinished: boolean;
  isLoadingStock: boolean;
  bagQuantity?: number;
  index?: number;
} & IAdjustedPickedQuantityActions;

const BoxItem = ({
  orderSkuIds,
  item,
  onIncreaseAdjustedPick,
  onDecreaseAdjustedPick,
  onConfirmExcessPicks,
  onAutoVerifyQuantity,
  isLoadingStock,
  isFinished,
  bagQuantity,
  index,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    article,
    sku,
    picks,
    confirmedQuantity,
    pickedQuantity,
    attributes,
    adjustedPickedQuantity = 0,
    verifiedQuantity,
    status,
  } = item;

  const isCancelled = status === LimaOrderStatus.Struken;

  const isRxBag = item.attributes.includes("RXBAG");
  const title = `${article.name}${
    !isRxBag ? ` (x${confirmedQuantity})` : bagQuantity ? ` (x${bagQuantity}) artiklar` : ""
  }`;
  return (
    <BoxItemCard>
      <BoxItemOverlays isCancelled={isCancelled} isLoading={isLoading} isRxBag={isRxBag} />

      <BoxItemHeader
        title={title}
        attributes={attributes}
        bundleId={item.orderSkuID}
        bundleIndex={index}
      />

      <BoxItemImage imageUrl={article.imageUrl} />

      <BoxItemSkuInfo
        skuId={sku.id}
        varunummer={item.varunummer}
        weight={article.weight}
        stock={sku.stock}
        showStock={!isRxBag}
        isLoadingStock={isLoadingStock}
      />

      <BoxItemPickProgress
        isLoading={isLoading}
        isCancelled={isCancelled}
        data={{
          itemId: item.id,
          confirmedQuantity,
          pickedQuantity,
          adjustedPickedQuantity,
          remainingQuantity: !isRxBag ? item.picks.remaining : 0,
          verifiedQuantity,
        }}
        actions={{
          onIncreaseAdjustedPick,
          onDecreaseAdjustedPick,
          onConfirmExcessPicks,
          onAutoVerifyQuantity,
        }}
      />
    </BoxItemCard>
  );
};

export default BoxItem;
